import * as React from 'react';

import { Organization, WebSite } from 'ha/components/LinkedData';
import { TopCities as list } from '../constants';
import { Blog } from '../types';
import Hero from './Hero';
import HomeHelmet from './HomeHelmet';
import TopCities from '../containers/TopCities';
import InfoSection from './InfoSection';
import FeaturedCities from '../containers/FeaturedCities';
import Separator from './Separator';
import BlogCards from './BlogCards';

interface Props {
  blogs: Blog[];
}

const HomeLayout: React.SFC<Props> = ({ blogs }) => {
  return (
    <div>
      <HomeHelmet />
      <Organization />
      <WebSite />
      <Hero />
      <TopCities list={list} />
      <Separator rotate />
      <InfoSection />
      <FeaturedCities />
      {blogs.length > 0 && (
        <React.Fragment>
          <Separator rotate />
          <BlogCards blogs={blogs} />
        </React.Fragment>
      )}
    </div>
  );
};

export default HomeLayout;
